<template>
    <section>
      <div v-if="loading" class="content content-centered">
        <pulse-loader></pulse-loader>
      </div>
      <div v-show="!loading" class="content">
        <div class="box">
          <div class="box-body">
            <div class="row">
              <div
                class="flash-message col-md-4 col-md-offset-4 text-center"
                v-if="flash"
              >
                <div class="alert" :class="'alert-' + flashType">
                  {{ flashMessage }}
                </div>
              </div>
            </div>
            <div id="details" class="row">
              <vue-form :state="formstate" @submit.prevent="onSubmit" class="row">
                <div class="col-sm-12">
                  <div class="col-sm-6">
                    <validate
                      auto-label
                      class="form-group required-field"
                      :class="fieldClassName(formstate.cityId)"
                    >
                      <label>City</label>
                      <select
                        required
                        name="cityId"
                        class="form-control"
                        :disabled="isCityDisable"
                        v-model="vehicleMaintenance.cityId"
                        v-on:change="getCityId($event.target.value)"
                      >
                        <option value="" disabled>Select City Name</option>
                        <option v-for="cityId in citys" :value="cityId.id"
                          >{{ cityId.name }}
                        </option>
                      </select>
                      <field-messages
                        name="cityId"
                        show="$touched || $submitted"
                        class="form-control-feedback"
                      >
                        <div slot="required">This is required field</div>
                      </field-messages>
                    </validate>
                  </div>
                  <div class="col-sm-6">
                    <validate
                      auto-label
                      class="form-group required-field"
                      :class="fieldClassName(formstate.vehicleId)"
                    >
                      <label>Vehicle</label>
                      <select
                        required
                        v-model="vehicleMaintenance.vehicleId"
                        @input="vehicleCheck()"
                        name="vehicleId"
                        class="form-control"
                      >
                        <option value="" disabled>Select Vehicle</option>
                        <option
                          v-for="(item, index) in vehicles"
                          :key="index"
                          :value="item.id"
                          :selected="
                            item &&
                              vehicleMaintenance.vehicleId &&
                              item.id === vehicleMaintenance.vehicleId
                          "
                        >
                          {{ item.name }}
                        </option>
                      </select>
                      <field-messages
                        name="vehicleId"
                        show="$touched || $submitted"
                        class="form-control-feedback"
                      >
                        <div slot="required">Vehicle is a required field</div>
                      </field-messages>
                    </validate>
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="col-sm-6">
                    <validate
                      auto-label
                      class="form-group required-field"
                      :class="fieldClassName(formstate.maintenanceDate)"
                    >
                      <label for="maintenanceDate">Maintenance Date</label>
                      <date-picker
                        required
                        id="maintenanceDate"
                        v-model="vehicleMaintenance.maintenanceDate"
                        lang="en"
                        name="maintenanceDate"
                        input-class="form-control"
                        width="100%"
                        use-utc="true"
                        format="DD-MM-YYYY"
                        @change="maintenanceDate()"
                      ></date-picker>
                      <field-messages
                        name="maintenanceDate"
                        show="$touched || $submitted"
                        class="form-control-feedback"
                      >
                        <div slot="required">
                          Maintenance date is a required field
                        </div>
                      </field-messages>
                    </validate>
                  </div>
  
                  <div class="col-sm-6">
                    <validate
                      auto-label
                      class="form-group required-field"
                      :class="fieldClassName(formstate.driverName)"
                    >
                      <label>Driver Name</label>
                      <select
                        v-on:change="driverChangeHandler"
                        required
                        name="driverName"
                        class="form-control"
                        v-model="vehicleMaintenance.driverName"
                      >
                        <option value="" disabled>Select Driver Name</option>
                        <option v-for="driver in Staff" :value="driver._id">{{
                          driver.firstName + " " + driver.lastName
                        }}</option>
                      </select>
                      <field-messages
                        name="driverName"
                        show="$touched || $submitted"
                        class="form-control-feedback"
                      >
                        <div slot="required">Driver name is required field</div>
                      </field-messages>
                    </validate>
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="col-sm-6">
                    <validate
                      auto-label
                      class="form-group required-field"
                      :class="fieldClassName(formstate.amount)"
                    >
                      <label>Amount</label>
                      <input
                        maxlength="10"
                        type="text"
                        name="amount"
                        class="form-control"
                        required
                        min="0"
                        v-model="vehicleMaintenance.amount"
                        placeholder="Amount"
                        pattern="\d{0,10}"
                      />
                      <field-messages
                        name="amount"
                        show="$touched || $submitted"
                        class="form-control-feedback"
                      >
                        <div slot="required">
                          Amount is a required field
                        </div>
                        <div slot="pattern">
                          Numbers are allowed.
                        </div>
                      </field-messages>
                    </validate>
                  </div>
  
                  <div class="col-sm-6">
                    <validate
                      auto-label
                      class="form-group required-field"
                      :class="fieldClassName(formstate.receipt)"
                    >
                      <label>Receipt</label>
                      <input
                        type="file"
                        id="fileName"
                        accept="image/png,image/jpeg,image/jpg,application/pdf"
                        name="receipt"
                        class="form-control"
                        @change="onDocumentchanged"
                      />
                      <field-messages
                        name="receipt"
                        show="$touched || $submitted"
                        class="form-control-feedback"
                      >
                        <div slot="receipt">
                          Receipt is required ,Please upload less than 5mb file.
                        </div>
                      </field-messages>
                      <div
                        class="border p-2 mt-3"
                        v-if="
                          $route.params &&
                            $route.params._id != '0' &&
                            vehicleMaintenance.receipt
                        "
                      >
                        <a
                          v-bind:href="vehicleMaintenance.receipt"
                          target="_blank"
                          >View</a
                        >
                      </div>
                    </validate>
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="col-sm-6">
                    <validate
                      auto-label
                      class="form-group required-field"
                      :class="fieldClassName(formstate.maintenanceType)"
                    >
                      <label>Maintenance Type</label>
                      <select
                        required
                        name="maintenanceType"
                        class="form-control"
                        v-model="vehicleMaintenance.maintenanceType"
                      >
                        <option value="" disabled>Select Maintenance Type</option>
                        <option value="Regular Service">Regular Service</option>
                      </select>
                      <field-messages
                        name="maintenanceType"
                        show="$touched || $submitted"
                        class="form-control-feedback"
                      >
                        <div slot="required">
                          Maintenance Type is required field
                        </div>
                      </field-messages>
                    </validate>
                  </div>
                </div>
              </vue-form>
              <div class="col-sm-12 text-right">
                <router-link :to="{ name: 'vehicleMaintenance' }">
                  <button class="mr-5 btn btn-default" type="button">
                    Cancel
                  </button>
                </router-link>
                <button
                  class="mr-2 btn gradientbt"
                  type="submit"
                  @click="createVehicleMaintenance"
                  :disabled="!(formstate.$dirty && formstate.$valid && this.docs)"
                  v-if="$route.params && $route.params._id == '0'"
                >
                  Save
                </button>
                <button
                  class="btn gradientbt mr-5"
                  type="submit"
                  @click="updateVehicleMaintenance"
                  :disabled="!((formstate.$dirty || isFileChange ) && ( formstate.$valid || isFileChange || isDriverChange || isVehicleEnable || isMaintenanceEnable))"
                  v-if="$route.params && $route.params._id != '0'"
                >
                  Update
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </template>
  
  <script>
  import store from "../../../store";
  import {
    formService,
    fileService,
    eventBus,
    dumpyardService,
  } from "../../../services";
  import { vehiclemaintenanceService } from "../../../services";
  import { EVENTS } from "../../../config";
  import { USER_ROLES } from "../../../config";
  import { mapState } from "vuex";
  
  export default {
    name: "vehiclemaintenancecreate",
    data() {
      return {
        isCityDisable: false,
        isMaintenanceEnable: false,
        isVehicleEnable: false,
        isDriverChange: false,
        isFileChange: false,
        ready: false,
        USER_ROLES: USER_ROLES,
        loading: false,
        flash: false,
        flashType: null,
        flashMessage: "",
        EVENTS: EVENTS,
        formstate: {},
        vehicleMaintenance: {
          driverName: "",
          vehicleId: "",
          cityId: "",
          maintenanceType: "",
        },
        oldVehicleMaintenance: {},
        vehicleMaintenanceId: [],
        managerss: {},
        vehicles: {},
        Staff: {},
        citys: {},
        docs: null,
      };
    },
    mounted: function() {
      this.getCityList();
    },
  
    methods: {
      fieldClassName: formService.fieldClassName,
     onDocumentchanged(event) {
        const fileName = document.getElementById("fileName");
        if (
          ["image/png", "image/jpeg", "image/jpg", "application/pdf"].includes(
            event.target.files[0]["type"]
          )
        ) {
          if (event.target.files[0].size > 1024 * 1024 * 5) {
            this.$snotify.error("File Size max limit of 5 MB", "Error!");
            fileName.value = "";
            event.preventDefault();
            return;
          } else {
            this.docs = event.target.files[0];
            if (this.docs) {
              this.isFileChange = true;
            } else {
              this.isFileChange = false;
            }
          }
        } else {
          this.$snotify.error("Upload .png, .jpeg, .jpg, .pdf files", "Error!");
          fileName.value = "";
        }
      },
  
      getCityList() {
        if (this.$store.state.auth.user.role.key === "cityAdmin") {
          const { _id, cityName } = this.$store.state.auth.user.cityId;
          this.citys = [
            {
              id: _id,
              name: cityName,
            },
          ];
          this.vehicleMaintenance["cityId"] = _id;
          this.getCityId(_id);
          this.isCityDisable = true;
          return;
        }
        this.loading = true;
        const params = {};
        let cityList = [];
        // params.page = 1;
        // params.limit = 999;
        this.$cityRepository
          .collectionCitysList(params)
          .then((res) => {
            this.loading = false;
            res.data.response.forEach((element) => {
              if (element.status === true) {
                cityList.push({
                  name: element.cityName,
                  id: element._id,
                });
              }
            });
            cityList.sort((item1, item2) => {
              return item1.name.toLowerCase() < item2.name.toLowerCase() ? -1 : 1;
            });
            this.citys = cityList;
          })
          .catch((error) => {
            this.loading = false;
            console.error("citys.requestFunction-error:", error);
            this.$snotify.error("Get citys list failed", "Error!");
          });
      },
  
      async uploadDocument() {
        if (this.docs) {
          const response = await fileService.fileUpload(this.docs, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          });
          if (response.data.length > 0) {
            return response.data[0]["Location"];
          }
          return "";
        } else {
          return "";
        }
      },
  
      getVehicleMaintenance() {
        const id = this.$route.params._id;
        return vehiclemaintenanceService
          .getVehicleMaintenanceDataByID(id)
          .then((response) => {
            this.getCityId(response.data.response.cityId._id);
            let data = [];
            data = response.data.response;
            data["driverName"] = response.data.response.driver
              ? response.data.response.driver._id
              : null;
            data["vehicleId"] = response.data.response.vehicleId
              ? response.data.response.vehicleId._id
              : null;
            data["cityId"] = response.data.response.cityId
              ? response.data.response.cityId._id
              : null;
            this.vehicleMaintenance = data;
  
            this.oldVehicleMaintenance = _.cloneDeep(this.vehicleMaintenance);
          })
          .catch((error) => {
            this.$snotify.error("Get Vehicle Maintenance failed", "Error!");
          });
      },
  
      getVehicleList(cityId) {
        this.loading = true;
        const params = {};
        params.$select = ["_id", "vNumber"];
        params.status = true;
        params.cityId = cityId;
        let vehicle_nameList = [];
        this.$vehicleDataRepository
          .list(params)
          .then((res) => {
            this.loading = false;
            res.data.docs.forEach((element) => {
              vehicle_nameList.push({
                name: element.vNumber,
                id: element._id,
              });
            });
            vehicle_nameList.sort((item1, item2) => {
              return item1.name.toLowerCase() < item2.name.toLowerCase() ? -1 : 1;
            });
            this.vehicles = vehicle_nameList;
          })
          .catch((error) => {
            this.loading = false;
            console.error("Vehicle.requestFunction-error:", error);
            this.$snotify.error("Vehicle list failed", "Error!");
          });
      },
  
      // getVehicleList(id) {
      //   let vehicle_nameList = [];
      //   return vehiclemaintenanceService
      //     .vehicleList(id)
      //     .then((res) => {
  
      //       res.data.response.forEach((element) => {
      //         if (element.status == true) {
      //           vehicle_nameList.push({
      //             name: element.vNumber,
      //             id: element._id,
      //           });
      //         }
      //       });
      //       vehicle_nameList.sort((item1, item2) => {
      //         return item1.name.toLowerCase() < item2.name.toLowerCase() ? -1 : 1;
      //       });
      //       this.vehicles = vehicle_nameList;
      //     })
      //     .catch((error) => {
      //       this.loading = false;
      //       console.error("Vehicle.requestFunction-error:", error);
      //       this.$snotify.error("Vehicle list failed", "Error!");
      //     });
      // },
  
      getStaffList(id) {
        this.loading = true;
        vehiclemaintenanceService
          .getDriverList(id)
          .then((res) => {
            this.loading = false;
            let staffList = res.data.response;
            staffList.sort((item1, item2) => {
              return item1.firstName.toLowerCase() < item2.firstName.toLowerCase()
                ? -1
                : 1;
            });
            this.Staff = res.data.response;
          })
          .catch((error) => {
            this.loading = false;
            this.$snotify.error("Get Staff list failed", "Error!");
          });
      },
  
      // getStaffList(cityId) {
      //         this.loading = true;
      //         const params = {};
      //         // params.$select = ['_id', 'vNumber']
      //         params.status = true
      //         params.cityId = cityId
      //         params.page = 1
      //         params.limit = 99999
      //             this.$vehicleMaintenanceDataRepository
      //             .list(params)
      //             .then((res) => {
      //                 this.loading = false;
      //                 let staffList = res.data.response;
      //                 staffList.sort((item1, item2) => {
      //                     return item1.name.toLowerCase() < item2.name.toLowerCase() ? -1 : 1;
      //                 });
      //                 this.Staff = staffList;
      //             })
      //             .catch((error) => {
      //                 this.loading = false;
      //                 console.error("Get Staff list failed", error);
      //                 this.$snotify.error("Get Staff list failed", "Error!");
      //             });
      //     },
  
      async createVehicleMaintenance() {
        this.loading = true;
        if (!this.docs) {
          this.$snotify.error(`Upload Receipt is required.`);
          this.loading = false;
          return;
        }
        let uploadedFileLocation = await this.uploadDocument();
        if (uploadedFileLocation !== "") {
          this.vehicleMaintenance.receipt = uploadedFileLocation;
        }
  
        this.vehicleMaintenance.driver = this.vehicleMaintenance.driverName;
        delete this.vehicleMaintenance.driverName;
        return vehiclemaintenanceService
          .createVehicleMaintenance(this.vehicleMaintenance)
          .then((response) => {
            this.loading = false;
            this.flash = false;
            this.$snotify.success(
              `The Vehicle Maintenance has been added successfully.!`
            );
            this.$router.push("/vehicleMaintenance");
          })
          .catch((error) => {
            this.loading = false;
            if (error.data.statusCode === 409) {
              this.$snotify.error(error.data.message, "Error!");
            } else {
              this.$snotify.error("vehicle Maintenance Create Failed.", "Error!");
            }
          });
      },
  
      clearChanges() {
        this.vehicleMaintenance = _.cloneDeep(this.oldVehicleMaintenance);
        this.formstate._reset();
      },
  
      async updateVehicleMaintenance() {
        this.loading = true;
        if (this.docs) {
          let uploadedFileLocation = await this.uploadDocument();
          if (uploadedFileLocation !== "") {
            this.vehicleMaintenance.receipt = uploadedFileLocation;
          }
        }
        this.vehicleMaintenance._id = this.$route.params._id;
        this.vehicleMaintenance.driver = this.vehicleMaintenance.driverName;
        const payload = {
          cityId: this.vehicleMaintenance.cityId,
          maintenanceDate: this.vehicleMaintenance.maintenanceDate,
          vehicleId: this.vehicleMaintenance.vehicleId,
          driver: this.vehicleMaintenance.driver,
          amount: this.vehicleMaintenance.amount,
          receipt: this.vehicleMaintenance.receipt,
          maintenanceType: this.vehicleMaintenance.maintenanceType,
          _id: this.vehicleMaintenance._id,
        };
  
        return vehiclemaintenanceService
          .updateVehicleMaintenance(payload)
          .then((response) => {
            let vname = response.data.response.vehicleId;
            this.loading = false;
  
            this.flash = false;
            this.formstate._reset();
            this.oldVehicleMaintenance = _.cloneDeep(this.vehicleMaintenance);
            this.$snotify.success(
              `The Vehicle Maintenance has been updated successfully.`
            );
            this.$router.push("/vehicleMaintenance");
          })
          .catch((error) => {
            this.loading = false;
            if (error.data.statusCode === 409) {
              this.$snotify.error(error.data.message, "Error!");
            } else {
              this.$snotify.error("Vehicle Maintenance Update Failed.", "Error!");
            }
          });
      },
      getCityId(cityId) {
        this.vehicleMaintenance.vehicleId = "";
        this.vehicleMaintenance.driverName = "";
        this.getVehicleList(cityId);
        this.getStaffList(cityId);
      },
      driverChangeHandler() {
        this.isDriverChange = true;
      },
      vehicleCheck(){
        this.isVehicleEnable = true;
      },
      maintenanceDate(){
        this.isMaintenanceEnable = true;
      }      
    },
  
    created() {
      const promises = [];
      this.loading = true;
      if (this.$route.params && this.$route.params._id && this.$route.params._id != '0') {
        promises.push(this.getVehicleMaintenance());
      }
      Promise.all(promises)
        .then(() => {
          this.loading = false;
          this.ready = true;
        })
        .catch((error) => {
          this.loading = false;
          this.$snotify.error("Create vehicleMaintenance failed", "Error!");
        });
    },
    beforeDestroy() {},
  
    fieldClassName: function(field) {
      if (!field) {
        return "";
      }
      if ((field.$touched || field.$submitted) && field.$valid) {
        return "has-success";
      }
      if ((field.$touched || field.$submitted) && field.$invalid) {
        return "has-danger";
      }
    },
  };
  </script>
  
  <style scoped>
  .required-field > label::after {
    content: "*";
    color: red;
    margin-left: 0.25rem;
  }
  
  .form-control-feedback {
    font-weight: 100;
    color: red;
    position: initial;
    text-align: left;
    height: auto;
    width: auto;
  }
  
  .has-danger {
    color: red;
  }
  
  .mt {
    margin-top: 7px;
  }
  
  .gradientbt {
    background: #0f6940;
    color: white;
  }
  
  .inputwrapper {
    position: relative;
  }
  
  .maps {
    position: absolute;
    top: 7px;
    right: 10px;
  }
  </style>
  


// WEBPACK FOOTER //
// vehicleMaintenanceCreate.vue?02c05008